import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingPage = () => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <Spinner animation="border" variant="dark"></Spinner>
    </div>
  );
};

export default LoadingPage;
